import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-asset-preview-lib/internal/shared/components/AsyncComponentErrorHandler';
export default Loadable({
  loader: () => import( /* webpackChunkName: "cta-image-preview" */'./CtaImagePreview').then(mod => mod.default).catch(AsyncComponentErrorHandler('cta-image-preview')),
  LoadingComponent: () => null
});